import ProductListService from './ProductListService';

export default new ProductListService('shop_compare');
